function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import { cmsActions } from '../../reducers/cms.reducer';
import { NavLink } from 'react-router-dom';
import ArticlesState from './Articles.context';
import ArticlesTable from './ArticlesTable.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import SubHeader from '../header/SubHeader.react';
var Articles = function Articles(_ref) {
  var articlesAction = _ref.articlesAction;
  var _useParams = useParams(),
    app = _useParams.app,
    itemID = _useParams.itemID;
  var cmsArticles = useSelector(function (s) {
    return s.cms.articles || {};
  });
  var cmsNavigation = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  var cmsPages = useSelector(function (s) {
    return s.pos.pages || {};
  });
  var _useState = useState({
      selectedApp: app || '',
      articles: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    page = _useState4[0],
    setPage = _useState4[1];
  useEffect(function () {
    articlesAction({});
  }, []);
  useEffect(function () {
    var arr = [];
    Object.values(cmsArticles).forEach(function (x) {
      if (!app || app && x.clientApp.includes(app)) arr.push(x);
    });
    setState(_objectSpread(_objectSpread({}, state), {}, {
      articles: arr
    }));
  }, [app, cmsArticles]);
  useEffect(function () {
    if (!itemID || !cmsNavigation[itemID]) setPage(null);else setPage(Object.values(cmsPages).find(function (x) {
      return x.internalUrl === cmsNavigation[itemID].internalUrl && x.clientApp === app;
    }) || null);
  }, [app, itemID, cmsNavigation, cmsPages]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubHeader, {
    route: "articles"
  }), /*#__PURE__*/React.createElement(ArticlesState.Provider, {
    value: [state, setState]
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, itemID && /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(NavLink, {
    className: "page__content--back",
    to: "/".concat(app, "/articles")
  }, "View All")), !itemID && /*#__PURE__*/React.createElement(ArticlesTable, {
    app: app
  }), itemID && page && /*#__PURE__*/React.createElement(ArticlesTable, {
    app: app,
    page: page
  }), itemID && !page && /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "No Articles"
  })))))));
};
var mdtp = {
  addModalAction: modalActions.add,
  articlesAction: cmsActions.articles
};
export default connect(null, mdtp)(Articles);